<script lang="ts">
  import Select from 'svelte-select';
  import { REGIONS } from './regions.js';

  let regionField = undefined;

  const groupBy = (item) => item.group;

  function handleSelect(event) {
    regionField = event.detail.value;
  }

  document.addEventListener('DOMContentLoaded', function() {
    function switchSteps(event, currentStep) {
          event.preventDefault();
          document.getElementById('step' + currentStep).style.display = 'none';
          document.getElementById('step' + (++currentStep)).style.display = 'block';
    }

    if (document.getElementById('newsletter-form')) {
      document
        .getElementById('form1')
        .addEventListener('submit', function (event) {
          switchSteps(event, 1);
        });

      // document
      //   .getElementById('form2')
      //   .addEventListener('submit', function (event) {
      //     switchSteps(event, 2);
      //   });

      document
        .getElementById('form3')
        .addEventListener('submit', function (event) {
          event.preventDefault();
          document.getElementById('step4').style.display = 'none';
          document.getElementById('step1').style.display = 'block';
        });

      document
        .getElementById('form2')
        .addEventListener('submit', function (event) {
          switchSteps(event, 2);
          document.getElementById('final-title').innerText = "Gotowe!";
          document.getElementById('final-desc').innerText = "Od teraz, raz dziennie system sprawdzi dla Ciebie podaną stronę i jeżeli znajdzie na niej nowe wiadomości poinformuje Cię o nich :)";
          document.getElementById('form3').style.display = 'none';

          var xhr = new XMLHttpRequest();
          xhr.open("POST", 'https://us-central1-bip-newsletter-net.cloudfunctions.net/add', true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.setRequestHeader("Access-Control-Allow-Origin", "*");

          xhr.onreadystatechange = function() {
              if (this.readyState === XMLHttpRequest.DONE) {

                if (this.status !== 200) {
                  document.getElementById('final-title').innerText = "Błąd!";
                  document.getElementById('final-desc').innerText = JSON.parse(this.response).message;
                  document.getElementById('form3').style.display = 'block';
                }

                switchSteps(event, 3);
              }
          }
          xhr.send(JSON.stringify({
            email: document.getElementById('email-field').value,
            website: regionField,
            title: '' // document.getElementById('title-field').value
          }));

        });
    }
  });
</script>


<section class="section bg-cover" id="zapisz-sie" style="background-image: url(/images/backgrounds/success-story.jpg)">
  <div class="container">
    <div class="row" id="newsletter-form">
      <div class="col-lg-6 col-sm-8 offset-lg-6 offset-sm-4">

        <div class="bg-white p-5" style="display: block; padding-bottom: 5rem !important;" id="step1">
          <h2 class="section-title">Podaj adres e-mail</h2>
          <p>Na podany adres otrzymasz wiadomość za każdym razem, gdy pojawią się nowe aktualności na śledzonej przez Ciebie stronie.</p>
          <form id="form1">
            <input type="email" class="form-control mb-3" id="email-field" name="email" required placeholder="Twój e-mail">
            <button type="submit" value="send" class="btn btn-primary float-right">
              Następny krok
            </button>
          </form>
        </div>

        <div class="bg-white p-5" style="display: none; padding-bottom: 5rem !important;" id="step2">
          <h2 class="section-title">Wybierz gminę</h2>
          <p>Wybierz gminę której aktualności chcesz otrzymywać.</p>
          <form id="form2">
            <!-- <input type="url" class="form-control mb-3" id="website-field" name="website" required placeholder="Adres strony"> -->
            <div style="margin-bottom: 1rem !important;">
              <Select items={REGIONS} {groupBy} id="website-field" on:select={handleSelect} placeholder="Wybierz gminę..."></Select>
            </div>
            <button type="submit" value="send" class="btn btn-primary float-right">
              Zapisz
            </button>
          </form>
        </div>

        <!-- <div class="bg-white p-5" style="display: none; overflow: hidden;" id="step3">
          <h2 class="section-title">Filtruj tytuły</h2>
          <p>Jeżeli chcesz otrzymywać tylko informacje o aktualnościach dotyczących konkretnego zgadnienia, podaj ciąg znaków który musi wystąpić w tytule, aby został dołączony do Twojego newslettera. Jeżeli chcesz otrzymywać wszystkie aktualności pozostaw pole puste.</p>
          <form id="form3">
            <input type="text" maxlength="30" class="form-control mb-3" id="title-field" name="title" placeholder="Fragment tytułu">
            <button type="submit" value="send" class="btn btn-primary float-right">
              Zapisz
            </button>
          </form>
        </div> -->

        <div class="bg-white p-5" style="display: none; overflow: hidden;" id="step3">
          <h2 class="section-title">Zapisywanie&hellip;</h2>
          <p class="text-center"><i class="ti-reload mb-xl-4 mb-lg-3 mb-4 loader-spin feature-icon"></i></p>
        </div>

        <div class="bg-white p-5" style="display: none; overflow: hidden;" id="step4">
          <h2 class="section-title" id="final-title">Gotowe!</h2>
          <p id="final-desc">Od teraz, raz dziennie system sprawdzi dla Ciebie podaną stronę i jeżeli znajdzie na niej nowe wiadomości poinformuje Cię o nich :)</p>
          <form id="form3">
            <button type="submit" value="send" class="btn btn-primary">
              Spróbuj raz jeszcze
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
